'use client'

import { useEffect } from 'react'

import { APP_NAME } from '@lib/constants'

export const useDocumentTitle = (title?: string | null) => {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME
  }, [title])
}
